const buttonSizes = (css, theme, styleUtils, caret) => ({
  xSmall: css`
    height: 24px;
    width: ${caret ? 36 : 24}px;
  `,
  small: css`
    height: 32px;
    width: ${caret ? 44 : 32}px;
  `,
  medium: css`
    height: 40px;
    width: ${caret ? 52 : 40}px;
  `,
});

const iconSizes = (css) => ({
  xSmall: css`
    font-size: 18px;
    width: 18px;
    height: 18px;
  `,
  small: css`
    font-size: 24px;
    width: 24px;
    height: 24px;
  `,
  medium: css`
    font-size: 32px;
    width: 32px;
    height: 32px;
  `,
});

const loaderSizes = {
  xSmall: 16,
  small: 18,
  medium: 20,
};

export default (css, theme, styleUtils) => ({
  buttonSizes: (caret) => buttonSizes(css, theme, styleUtils, caret),
  iconSizes: iconSizes(css),
  loaderSizes,
});
